module.exports = __webpack_public_path__ + "partnersBanner_bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/partnersBanner_bg.jpg
// module id = 1860
// module chunks = 0